export { AiTenantModelAllowlist } from '../entities'
export type { AiTenantModelAllowlist as default } from '../entities'
